module.exports = __webpack_public_path__ + "static/media/mobile-review.2fe10dd9.png";